module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAARCAYAAAACCvahAAAABHNCSVQICAgIfAhkiAAAAPZJREFUOE+FkwFxAjEQRd8qoA5AAnVAFVAJdQI4qINSB62CIgEJoABQ8Dufyd2EkEt2JjM3Sd7uz+6/kPQBfNGPK/AWEcfhakgSsAMOHf4TOEXEewk7YxOWdD+PiFUVlvQCbIBlRcWwZ9leu0H2vbIkS3MPxndNPGXhOyX8JK0GS9oCq0lYkrPPC/jmbjdhwB29TEh+Tefdyq6ex7Vb2eNI0uyBMr5TU5uVfwCPrgxPw2sabrktb5g9+5dm64znJNv7s5TkN7dlDts5NofD38cEjzZMnj4NakY4l1fzb9MkBWwFa2Df+cPsg3MUsLtrsNblh3kD23+/CsAInlxXzAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/paste.png
// module id = jWyI
// module chunks = 3